import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, Output, ViewChild, EventEmitter, SimpleChanges, OnDestroy, OnChanges, AfterViewInit, Inject, Renderer2 } from '@angular/core';
import { FileUpload, Post, PostField, Template } from '../container';
import { HttpClient } from '@angular/common/http';
import { FirestoreService } from '../firestore-service.service';
import { SearchService } from '../search.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Observable } from 'rxjs';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { AiassistantpopupComponent } from '../aiassistantpopup/aiassistantpopup.component';
import { environment } from 'src/environments/environment';
import { GeminiService } from '../gemini.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SimilarcontentComponent } from '../similarcontent/similarcontent.component';
import { CommentlistComponent } from '../commentlist/commentlist.component';
import { LinkedcontentComponent } from '../linkedcontent/linkedcontent.component';
import { ChecklistComponent } from '../checklist/checklist.component';
import { IcescoreComponent } from '../icescore/icescore.component';
import { ProgresshillComponent } from '../progresshill/progresshill.component';
import { TimetrackerpopupComponent } from '../timetrackerpopup/timetrackerpopup.component';
import { TaskdatesComponent } from '../taskdates/taskdates.component';
import { DiscussionchannellazyComponent } from '../discussionchannellazy/discussionchannellazy.component';
import { SafeHtmlPipe } from '../safe-html.pipe';
import { LinkednotesComponent } from '../linkednotes/linkednotes.component';
import { AttachedfilesComponent } from '../attachedfiles/attachedfiles.component';
import { UploadfileComponent } from '../uploadfile/uploadfile.component';
import { PeoplesearchpopupComponent } from '../peoplesearchpopup/peoplesearchpopup.component';
import { TableComponent } from '../table/table.component'; 
import { DropdownComponent } from '../dropdown/dropdown.component';
import { ProgressbarComponent } from '../progressbar/progressbar.component';
import { QuizComponent } from '../quiz/quiz.component';
import { UserdetailspopupComponent } from '../userdetailspopup/userdetailspopup.component';
import { InlinetutorialComponent } from '../inlinetutorial/inlinetutorial.component';
import { ColorCircleModule } from 'ngx-color/circle';

@Component({
    selector: 'app-details2',
    templateUrl: environment.site == "productly" ? "./details2.component.productly.html" : "./details2.component.wroolo.html",
    styleUrl: './details2.component.scss',
    standalone: true,
    imports: [
      CommonModule, 
      FormsModule, 
      NgxEditorModule, 
      SimilarcontentComponent, 
      CommentlistComponent, 
      LinkedcontentComponent, 
      ChecklistComponent, 
      IcescoreComponent, 
      ProgresshillComponent, 
      TimetrackerpopupComponent, 
      TaskdatesComponent,
      DiscussionchannellazyComponent,
      SafeHtmlPipe,
      LinkednotesComponent,
      AttachedfilesComponent,
      UploadfileComponent,
      PeoplesearchpopupComponent,
      TableComponent,
      DropdownComponent,
      ProgressbarComponent,
      QuizComponent,
      UserdetailspopupComponent,
      InlinetutorialComponent,
      DragDropModule,
      ColorCircleModule,
      ConfirmingDialogComponent
    ],
})
export class Details2Component implements OnDestroy {
  @Input() menuItems: {key: string, name: string, color: string}[] = [];
  @Input() templates: Template[] = [];
  @Input() post: Post = {"authorKey": "", "authorName": "", "categoryKey": "", "color": "", "commentCount": 0, "nameHTML": "", "contentRowsCount": 0, "coverImageURL": "", "dateOfCreation": new Date(), "dateOfUpdate": new Date(), "fields": [], "formattedDate": "", "imageURLs": [], "isDeleted": false, "isDownloadAvailable": false, "isNewPost": true, "key": "", "lastCommentDate": new Date(), "loggedUserDisplayName": "", "loggedUserKey": "", "organizationKey": "", "name": "", "projectKey": "", "projectName": "", "tags": [], "templateKey": "", "title": "", "viewCount": 0, "contentType": "", "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": 0, "startDate": new Date(), "endDate": new Date(), "manHours": 0, "isSelected": false, "templateName": "", "areKidsColored": false, "areKidsTagged": false, "isCompleted": false, "parentName": "", "isParent": false, "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "milestoneKey": "", "isChecked": false, "description": "", "fileType": ""};
  @Input() projectName: string = "";
  @Input() userId: string = "";
  @Input() userDisplayName: string = "";
  @Input() isNewPost = false
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() channelKey: string = "";
  @Input() type: string = ""; // type of content workpackage, post, comment
  @Input() channelName = ""
  @Input() htmlName = ""
  @Input() launchedAsSubcomponent = false
  @Input() imageURLs: string[] = []
  @Input() isDownloadAvailable = false
  @Input() postKey = ""
  @Input() postEmbedding: number[] = []
  @Input() fields: PostField[] = []
  @Input() name = "";
  @Input() color = "";
  @Input() areKidsColored: boolean = true
  @Input() areKidsTagged: boolean = true
  @Input() isDeleted = false
  @Input() isCompleted = false
  @Input() isRead = false
  @Input() isTop = false
  @Input() isFavourite = false
  @Input() templateKey: string = "note"
  @Input() fieldKeyWithLinks: number = -1
  @Input() columnKey = ""
  @Input() isReadOnly = false
  @Input() embeddingModel = ""
  @Input() captureImage = false
  @Input() launchedAsDialog = true
  @Input() editModeSelected = true
  @Input() bookMode = false
  @Input() globalTags: string[] = []
  @Input() startDate = ""
  @Input() endDate = ""
  @Input() selectedTeamKey = ""
  @Input() progressPercent = 0
  @Input() manHours = 0
  @Output() listenContent = new EventEmitter<boolean>();
  @Output() closePopup = new EventEmitter<{isDeleted: boolean, isPostUpdated: boolean, isListening: boolean, name: string, htmlName: string}>()
  @Output() sendColorUpdate = new EventEmitter<string>()
  @Output() sendStatusUpdate = new EventEmitter<string>()
  @Output() sendNameUpdate = new EventEmitter<{name: string, htmlName: string}>()
  @Output() sendIsComplete = new EventEmitter<boolean>()
  @Output() sendDelete = new EventEmitter<boolean>()
  @Output() sendCoverImageUpdate = new EventEmitter<string>()
  @Output() contentIsLoaded = new EventEmitter<{key: string, isLoaded: boolean}>()
  isAnonymous: boolean = true
  channelPath = ""
  editor = new Editor()
  editors: { showToolbar: boolean}[] = [];
  aggregatedContent = ""
  title = ""
  subtitle = ""
  isListening: boolean = false // determines if content list should be listened to
  isAutofocusSet: boolean = false
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    //['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  selectedFiles?: FileList;
  currentFileUpload?: FileUpload;
  percentage = 0;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  linkedPosts: Post[] = [];
  isAddPostClicked: boolean = false
  addedPostLink: string = ""
  parentName = "";
  blindColor = "#888888";
  isColorPalleteVisible: boolean = false
  tagList: string[] = [];
  filteredTags: Observable<string[]> = new Observable;
  templateIndex: number = -1
  token = ""
  showSearchwModal = false
  showTimeTracker = false
  showUserDetailsModal = false
  isPostUpdated = false
  assignedUsers: {"id": string, "img": string, "name": string, "email": string, "show":  boolean}[] = []
  isChatVisible = false
  tutorialTooltips: {"object": string, "tooltipSelector": string, "tooltipCaption": string}[] = [
    {"object": "#header", "tooltipSelector": "#tooltippopup", "tooltipCaption": "Here you can see details of a task or a note"},
    {"object": "#template", "tooltipSelector": "#tooltippopup", "tooltipCaption": "Each record is created based on predefined templates."},
    {"object": "#section", "tooltipSelector": "#tooltippopup", "tooltipCaption": "But you can rearrange sequence of sections and add new ones."},
    {"object": "#save", "tooltipSelector": "#tooltippopup", "tooltipCaption": "Click here to save your updates and quit."},
  ]
  tutorialTooltipMessage = ""
  columns: {"key": string, "name": string, "sequence": number}[] = []
  statusName = ""
  quizKey = ""
  quizes: {"key": string, "name": string, "description": string}[] = []
  isLoadingLabelVisible = false
  quizName = ""
  quizDescription = ""
  didJustPaste = false
  fieldToBeReplacedWhenPasting = -1
  currentFieldIndex = -1
  showAddTemplatePopup = false
  addTemplateName = ""
  scrapedPage = ""
  pastedLink = ""
  loadingMessage = "Please wait, while data is loaded."
  lastImageURL = ""
  shiftKeyPressed = false
  pickedDate = ""
  link = "https://prodcutly.web.app/details/"+this.organizationKey+"/"+this.postKey
  isCommandEnterHit = false
  isVisible = true
  doShow = false
  visibleContextMenuIndex = -1
  editedTagIndex = -1
  editedTag = ""
  isHovering: boolean = true;
  mouseX: number = 0;
  mouseY: number = 0;
  colors: string[] = []
  isSlashDetected: boolean = false;
  focusedFieldIndex = -1
  personas: {"name": string, "key": string, "description": string, "isSelected": boolean}[] = []
  site = environment.site

  @ViewChild('tooltipElement') tooltipElement: ElementRef;

  constructor(public dialogRef: MatDialogRef<Details2Component>, @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient, private firestoreService: FirestoreService, private searchService: SearchService, private dialog: MatDialog, private search: SearchService, private gemini: GeminiService, private cdr: ChangeDetectorRef, private renderer: Renderer2) { 
    this.colors = [...this.firestoreService.colors]
    this.type = this.data.type
    this.post = this.data.post;
    if (this.post.tags == undefined) {
      this.post.tags = []
    }
    this.isCompleted = data.isCompleted
    this.post.fields = data.fields
    this.fields = data.fields
    this.templates = this.data.templates;
    this.menuItems = this.data.menuItems;
    this.userId = this.data.userId
    this.organizationKey = this.data.organizationKey
    this.projectKey = this.data.projectKey
    this.projectName = this.data.projectName
    this.channelKey = this.data.channelKey
    this.parentName = this.data.parentName
    this.columnKey = this.data.columnKey
    this.isReadOnly = this.data.isReadOnly
    this.templateKey = this.data.templateKey
    this.globalTags = this.data.globalTags || []
    this.startDate = this.data.startDate
    this.endDate = this.data.endDate
    this.manHours = this.data.manHours
    this.progressPercent = this.data.progressPercent
    this.captureImage = this.data.captureImage || false
    this.color = this.data.color || "#ffffff"
    this.embeddingModel = this.data.embeddingModel
    if (this.embeddingModel == undefined) {
      this.embeddingModel = "gemini-embedding-001"
    }
    if (this.isReadOnly == undefined) {
      this.isReadOnly = false
    }
    if (this.color == null) {
      this.color = "#ffffff"
    }
    let HTMLname = this.data.HTMLname
    if ((HTMLname == undefined)||(HTMLname == "")) {
      this.name = this.data.name
    } else {
      this.name = this.data.HTMLname
    }
    this.fieldKeyWithLinks = data.fieldKeyWithLinks
    this.isPostUpdated = false // open dialog for view only at first
    this.postKey = this.data.key
  }

  ngOnInit() {
    if (this.isDeleted == true) {
      this.dialog.closeAll();
      this.dialog.open(ConfirmingDialogComponent, {
        width: '400px',
        data: {"content": "This content has been deleted.", "onlyCloseButton": true}
      });
    }
    this.post.color = this.color
    if (this.color == "#ffffff") {
      this.color = this.blindColor
    }
    if (this.channelKey == "") {
      this.channelKey = this.post.key
    }
    setTimeout(() => {  // this is necessary to avoid ExpressionChangedAfterItHasBeenCheckedError
      this.getQuizes()
      this.initiatePage()
      this.aggregatedContent = this.stripTags(this.search.aggregateContent(this.fields))
    },0)
    this.getAssignedUser()
    this.firestoreService.incrementViewCount(this.organizationKey, this.postKey)
    this.name = this.firestoreService.stripHTML(this.getName(), 270)
  }
 

 ngOnDestroy(): void {
  document.removeEventListener('keydown', this.handleKeyboardEvent);
  this.name = this.getName()
  if (this.color != this.blindColor) {
  }
  this.cdr.detectChanges(); 
}

@HostListener('document:keydown', ['$event'])
handleKeyboardEvent(event: KeyboardEvent) {
  this.visibleContextMenuIndex = -1 // hide context menu when any key is pressed
  if (event.shiftKey && event.key === 'Enter') {
    if (this.currentFieldIndex > -1 && this.fields[this.currentFieldIndex].type == 'html') {
      this.addField(this.currentFieldIndex, "html", "")
    }
  }
  if (event.ctrlKey && event.key === 'g') { // ctrl+d to add date alert
    this.addField(this.currentFieldIndex, "datealert", "")
  }
  if (event.ctrlKey && event.key === 'd' && this.currentFieldIndex != -1) { // ctrl+d to delete section
    this.deleteField(this.currentFieldIndex, false)
  }
  if (event.key === 'Escape') {
    this.hideContextMenu()
    this.showToolbar(this.currentFieldIndex, false)
    this.visibleContextMenuIndex = -1
    event.stopPropagation();
  }
}

onMouseMove(event: MouseEvent): void {
  this.mouseX = event.offsetX;
  this.mouseY = event.offsetY;
}

showGrabIcon(show: boolean, event?: MouseEvent): void {
  this.isHovering = show;

  if (show && event) {
      this.mouseX = event.clientX;
      this.mouseY = event.clientY - 350;
  }
}

selectPersona(personaKey: string) {
  this.post.tags.length = 0
  this.personas.forEach(persona => {
    if (persona.key == personaKey) {
      persona.isSelected = !persona.isSelected
    }
    if (persona.isSelected == true) {
      this.post.tags.push(persona.name)
    }
  })
  this.firestoreService.updateContentTags(this.organizationKey, this.postKey, this.post.tags).then(() => {
   // this.firestoreService.showSnackBar("The tag has been removed.")
  })
}

async getPersonas() {
  await this.firestoreService.getTags(this.organizationKey).then((result: any) => {
    let personas: {"name": string, "key": string, "description": string, "isSelected": boolean}[] = []
    result.docs.forEach((child: any) => {
      const teamKey = child.get("teamKey")
      if (teamKey == this.selectedTeamKey) {
        let isSelected = false
        if (this.post.tags.includes(child.get("name"))) {
          isSelected = true
        }
        personas.push({"name": child.get("name"), "key": child.id, "description": child.get("description"), "isSelected": isSelected})
      }
    })
    this.personas = personas
  })
}

async prepareFieldData() {
  this.firestoreService.getKanbanColumns(this.organizationKey, this.projectKey).then(result => {
    this.columns = result
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].key == this.columnKey) {
        this.statusName = this.columns[i].name
      }
    }
    this.columns.sort((a, b) => {
      return a.sequence - b.sequence;
    });
  })
  const template = this.templates.find(template => template.key == this.templateKey)
  if (template) {
    this.title = template.title
    this.subtitle = template.subtitle
  }

  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].type == "dropdown" || this.fields[i].type == "multidropdown") { 
      if (this.fields[i].content != "") { // if content is not empty, it means that the field is not new
      const oldContent = JSON.parse(this.fields[i].content)
      for (let j = 0; j < oldContent.options.length; j++) {
        if (oldContent.options[j].selected == true) {
          oldContent.selected = j
        } else {
          oldContent.options[j].selected = false
        }
      }
      this.fields[i].content = JSON.stringify(oldContent)
    } else { // if content is empty, it means that the field is new
      if (template) {
        const field = template.fields.find(field => field.key == this.fields[i].key)
        if (field) {
          let options = []
          let isMultichoice = false
          let isPersonaDropdown = false
          try { 
            const parsed = JSON.parse(field.contentJson)
            isPersonaDropdown = parsed.isPersonaDropdown || false
            if (isPersonaDropdown == true) {
              for (let j = 0; j < this.personas.length; j++) {
                options.push({"label": this.personas[j].name, "selected": false})
              }
            } else {
              options = parsed.options
            }
            isMultichoice = parsed.isMultichoice || false
          } catch (error) {
          }
          const content = { "selected": 0, "label": field.name || "", "options": options, "isMultichoice": isMultichoice, "isPersonaDropdown": isPersonaDropdown }
          this.fields[i].content = JSON.stringify(content)
        }
      }
    }
  }
  if (this.fields[i].type == 'progressbar') {
    if (this.fields[i].content == "") {
      const template = this.templates.find(template => template.key == this.templateKey)
      const field = template?.fields.find(field => field.key == this.fields[i].key)
      const content = { "value": 0, "label": field?.name || "" }
      this.fields[i].content = JSON.stringify(content)
    }
  }
  if (this.fields[i].content == "" && this.fields[i].type == "label") { // fill in labels if they are empty, this happens when new task is added
    this.fields[i].content = this.fields[i].label
  }
  if (this.fields[i].content == "html" || this.fields[i].type == "plain") {
    const template = this.templates.find(template => template.key == this.templateKey)
    const field = template?.fields.find(field => field.key == this.fields[i].key)
    if (field) {
      let placeholder = "type here"
      try {
        const parsed = JSON.parse(field.contentJson)
        placeholder = parsed.placeholder || "type here"
      } catch (error) {}
      this.fields[i].placeholder = placeholder
      this.fields[i].label = field.name
    }
  }
}
}

async initiatePage() { // loads data for the post or workpackage 
  await this.getPersonas()
  await this.prepareFieldData()
  await this.firestoreService.incrementViewCount(this.organizationKey, this.postKey)
  if (this.isReadOnly == undefined) {
    this.isReadOnly = false
  }
  if (this.type == "workpackage") {
    this.firestoreService.getKanbanColumns(this.organizationKey, this.projectKey).then(result => { // get kanban columns, it is needed for changing status of workpackage
      this.columns = [...result]
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].key == this.columnKey) {
          this.statusName = this.columns[i].name
        }
      }
      this.columns.sort((a, b) => {
        return a.sequence - b.sequence;
      });
    })
    if (this.parentName != undefined && this.parentName.length > 20) {
      this.parentName = this.parentName.slice(0, 20)+"..."
    }
  }
  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].content == "" && this.fields[i].type == "label") { // fill in labels if they are empty, this happens when new task is added
      this.fields[i].content = this.fields[i].placeholder
    }
  }
  const expandedFields = await this.retrieveFieldsExpansionStatus()
  for (let i = 0; i < this.fields.length; i++) {
    if (this.isNewPost == true || expandedFields.length == 0) {
      this.fields[i].isExpanded = true
    } else {
      this.fields[i].isExpanded = expandedFields.includes(this.fields[i].key)
    }
  }
  if (this.color == null || this.color == undefined) {
    this.color = "#ffffff"
  }
  if (this.name == undefined) {
    this.name = "No name"
  }
  this.channelName = "Content channel "+this.stripTags(this.name.slice(20)+"...")
  this.channelPath = "organizations/"+this.organizationKey+"/channels/"+this.channelKey
  if ((this.htmlName == undefined)||(this.htmlName == "")) {
  //  this.name = this.data.name
  } else {
    this.name = this.htmlName
  }
  this.isPostUpdated = false // open dialog for view only at first
  const firstHHTMLSection = this.initiateEditors()
  if (firstHHTMLSection > -1 && this.site != "productly") {
    this.showToolbar(firstHHTMLSection, true)
  }
  this.contentIsLoaded.emit({key: this.postKey, isLoaded: true})
  this.listenContent.emit(true)
}


copyLink() {
  this.link = "https://app.prodely.com/details/"+this.organizationKey+"/"+this.postKey
  navigator.clipboard.writeText(this.link).then(() => {
    this.firestoreService.showSnackBar("Link copied to clipboard.")
  }).catch(err => {
    console.error('Failed to copy the link: ', err);
  });

}

initiateEditors() {
  this.editors.length = 0
  let firstHHTMLSection = -1

  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].type == "html" && firstHHTMLSection == -1) {
     firstHHTMLSection = i
    }
    this.editors.push({"showToolbar": false}) // TU POWINIEN BYĆ WARUNEK, ABY DODAWAĆ EDYTOR TLYKO DLA HTML ALE NIE UMIEM PO STRONIE WWW ODLICZAC INDEKSÓW TYLKO DLA PÓL HTML, WIĘC TAK NADMIAROWO GENERUJĘ OBIEKTY EDYTORA!!!
  }
  this.detectLinkFields()
  return firstHHTMLSection
}

onPaste(event: any, fieldIndex: number) {
  this.visibleContextMenuIndex = -1 // hide context menu when any key is pressed
  let doTextSplit = false
  if (this.shiftKeyPressed == true) {
    doTextSplit = true
  }
  if (doTextSplit == true) {
    const text = this.fields[fieldIndex].content
    const key = this.fields[fieldIndex].key
    const splittedText: string[] = text.split(/(<\/p>|<\/h1>|<\/h2>|<\/h3>|<\/h4>|<\/h5>|<br\/>)|\n\n/);
    let i = 0
    let firstFieldAdded = -1
    while (i < splittedText.length) { // tries to cut text into smaller pieces to paste them into separate fields
      if (splittedText[i] != undefined && splittedText[i].length > 1 && splittedText[i] != "</p>" && splittedText[i] != "</h1>" && splittedText[i] != "</h2>" && splittedText[i] != "</h3>" && splittedText[i] != "</h4>" && splittedText[i] != "</h5>") {
        let suffix = ""
        if (splittedText[i+1] != undefined) {
          suffix = splittedText[i+1]
        }
        this.addField(fieldIndex+i-1, "html", splittedText[i] + suffix, false)
        firstFieldAdded = fieldIndex+i
      }
      i += 1
    }

    const fi = this.getFieldByKey(key)
    if (fi > -1) {
        this.deleteField(fi, true)
    }
  } else {
   // this.addField(fieldIndex+i-1, "html", , false)
  }
  this.detectLinkFields()
}

updatePickedDate(fieldIndex: number) {
  this.signInForEmail() // I assume that if user changes date, he wants to be notified about the content
}

onChange(html: object, fieldIndex: number) {
  this.visibleContextMenuIndex = -1 // hide context menu when any key is pressed  
  this.pastedLink = this.firestoreService.stripHTML(html.toString()) 
  if (this.fields[fieldIndex].content == "<p></p>") {
    this.fields[fieldIndex].content = ""
  }

 /* 
  if (this.didJustPaste == true) {
    this.didJustPaste = false
    if (this.fieldToBeReplacedWhenPasting > -1) {
      this.deleteField(this.fieldToBeReplacedWhenPasting, true)
    }
    this.fieldToBeReplacedWhenPasting = -1
  }*/
  this.aggregatedContent = this.stripTags(this.search.aggregateContent(this.fields))
}

detectLinkFields() {
  for (let i = 0; i < this.fields.length; i++) {
    this.fields[i].links.length = 0
    let link = this.fields[i].content
    link = this.firestoreService.stripHTML(link)
    if (this.firestoreService.isValidUrl(link)) {
      this.fields[i].links.push(link)
    }
  }
}

switchViewMode() {
  this.editModeSelected = !this.editModeSelected
}

getFieldByKey(key: string) {
  for (let i =0; i < this.fields.length; i++) {
    if (this.fields[i].key == key) {
      return i
    }
  }
  return -1
}

changeEmbeddingModel() {
  this.embeddingModel = "gemini-embedding-001"
}

getQuizes() {
  this.isLoadingLabelVisible = true
  this.firestoreService.getQuizes(this.organizationKey).then(result => {
    this.quizes = result
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type == 'quiz') {
        this.selectQuiz(i)
      }
    }
    this.isLoadingLabelVisible = false
  }).catch(() => {
    this.isLoadingLabelVisible = false
  })
}

selectQuiz(fieldIndex: number) { // TU JEST BŁAD BO ZAKLADA SIE ZE W POSCIE BEDZIE TYLKO JEDEN QUIZ!!!
  this.quizKey = this.fields[fieldIndex].content
  const index = this.getQuizIndex(this.quizKey)
  this.quizName = this.quizes[index].name
  this.quizDescription = this.quizes[index].description
}

getQuizIndex(quizKey: string) {
  for (let i = 0; i < this.quizes.length; i++) {
    if (quizKey == this.quizes[i].key) {
      return i
    }
  }
  return -1
}

updateStatus(index: number) { // changes status of task
  this.isPostUpdated = true
  this.columnKey = this.columns[index].key
  this.statusName = this.columns[index].name
  this.firestoreService.updateWorkpackageStatus(this.organizationKey, this.projectKey, this.userId, this.postKey, this.columnKey).then(() => {
    this.sendStatusUpdate.emit(this.columnKey)
  })
}


onKeyUp(event: MouseEvent | KeyboardEvent, editorIndex: number) {
  this.editor.commands.exec()
  this.shiftKeyPressed = false
  const strippedContent = this.fields[editorIndex].content.replace(/<[^>]*>?/gm, '')
 if (strippedContent.endsWith(" /")) { // detect slash at the end of the content and show context menu
  this.focusedFieldIndex = editorIndex
  const inputElement = document.getElementById("editor-"+editorIndex) as HTMLInputElement
  this.showContextMenu(event, inputElement)
 } else {
  this.hideContextMenu()
 }
}

showContextMenu(event: MouseEvent | KeyboardEvent, inputElement: HTMLInputElement | HTMLTextAreaElement) {
  if (event instanceof KeyboardEvent && event.key !== 'Escape') {
    this.isSlashDetected = true
    const contextMenu = document.getElementById("context-menu-slash")
    if (contextMenu != null) {
      const caretPosition = this.getCaretPosition(inputElement);
      contextMenu.style.display = "block"
      contextMenu.style.left = caretPosition.x+"px" 
      contextMenu.style.top = caretPosition.y+"px"
          // Using setTimeout to ensure the context menu is rendered before focusing
      setTimeout(() => {
        if (contextMenu) {
          this.renderer.selectRootElement(contextMenu, true).focus();
        }
      }, 0);
    }
  }
}

hideContextMenu() {
  this.isSlashDetected = false
  this.focusedFieldIndex = -1
  const contextMenu = document.getElementById("context-menu-slash")
  if (contextMenu != null) {
    contextMenu.style.display = "none"
  }
}

getCaretPosition(input: HTMLInputElement | HTMLTextAreaElement) {
  if (input instanceof HTMLInputElement) {
    return this.getCaretCoordinatesForInput(input)
  } else {
    return this.getCaretPositionForTextArea()
  }
}

getCaretPositionForTextArea() {
  let caretPosition = { x: 0, y: 0 };
  const selection = window.getSelection();
  if (selection && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    const rects = range.getClientRects();

    if (rects.length > 0) {
      // Get the position of the first rectangle representing the anchor position of the caret
      const rect = rects[0];
      caretPosition.x = rect.left + window.scrollX; // Add window scroll for accurate position
      caretPosition.y = rect.top + window.scrollY;   // Add window scroll for accurate position
    }
  }
  return caretPosition
}

getCaretCoordinatesForInput(input: HTMLInputElement) {
  const caretIndex = input.selectionStart || 0;
  const text = input.value.substring(0, caretIndex);
  const mirrorDiv = this.createMirrorElement(input);
  
  // Create a text node with the text before the caret
  mirrorDiv.textContent = text;
  
  // Create a span to mark the caret position
  const caretSpan = document.createElement("span");
  // Insert a non-breaking space if at end
  caretSpan.textContent = input.value.length === caretIndex ? "\u200b" : "";
  mirrorDiv.appendChild(caretSpan);

  // Get the caret coordinates relative to the mirror div
  const rect = caretSpan.getBoundingClientRect();
  const mirrorRect = mirrorDiv.getBoundingClientRect();
  
  // Cleanup the mirror element afterwards.
  document.body.removeChild(mirrorDiv);
  
  // Calculate position relative to the input element
  const offsetX = rect.left - mirrorRect.left;
  const offsetY = rect.top - mirrorRect.top;

  // Position of the input element (accounting for window scroll etc.)
  const inputRect = input.getBoundingClientRect();
  
  return {
    x: inputRect.left + offsetX + window.scrollX,
    y: inputRect.top + offsetY + window.scrollY,
  };
}

createMirrorElement(input: HTMLInputElement): HTMLDivElement {
  const mirrorDiv = document.createElement("div");
  const computed = window.getComputedStyle(input);
  mirrorDiv.style.position = "absolute";
  mirrorDiv.style.visibility = "hidden";
  mirrorDiv.style.whiteSpace = "pre-wrap"; // or "pre" based on your use case
  mirrorDiv.style.font = computed.font;
  mirrorDiv.style.letterSpacing = computed.letterSpacing;
  mirrorDiv.style.padding = computed.padding;
  mirrorDiv.style.border = computed.border;
  mirrorDiv.style.overflow = "hidden";
  mirrorDiv.style.width = computed.width;
  mirrorDiv.style.height = computed.height;
  document.body.appendChild(mirrorDiv);
  return mirrorDiv;
}

showChat() {
  this.isChatVisible = true
}

hideChat() {
  this.isChatVisible = false
}

completeWorkpackage(isCompleted: boolean) {
  let message = "Do you want to mark this task as completed?"
  let snackMessage = "The task has been marked as completed."
  if (isCompleted == false) {
    message = "Do you want to mark this task as not completed?"
    snackMessage = "The task has been marked as not completed"
  }
  const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
    data: {"content": message, "onlyCloseButton": false}
  });
  dialogConfirmingRef.afterClosed().subscribe((result) => { // if file was already added, leave popup after showing message
    if (result == true) {
      this.isCompleted = isCompleted
      this.isPostUpdated = true
      this.sendIsComplete.emit(isCompleted)
      this.firestoreService.showSnackBar(snackMessage);
      this.firestoreService.completeWorkpackage(this.organizationKey, this.projectKey, this.userId, this.postKey, isCompleted)
    } 
  })
}

pinToTop(isTop: boolean) { // set content on top of feed list
  this.isPostUpdated = true
  this.isTop = isTop
  if (isTop == true) {
    this.isRead = false
   // this.data.isRead = this.isRead
  }
 // this.data.isTop = isTop
}

setFavourite(isFav: boolean) { // set content on top of feed list
  this.isPostUpdated = true
  this.isFavourite = isFav
 // this.data.isFavourite = isFav
}

readContent(isRead: boolean) { // set content on the bottom of feed list
  this.isPostUpdated = true
  this.isRead = isRead
  if (isRead == true) {
    this.isTop = false
  //  this.data.isTop = this.isTop
  }
//  this.data.isRead = isRead
}

getAssignedUser() {
  this.assignedUsers.length = 0
  this.firestoreService.getUsersByWorkpackage(this.organizationKey, this.postKey).then(snap => {
    snap.forEach(u => {
      const id = u.id
      this.firestoreService.getUserData(id).then(uu => {
        const name = uu.get("displayName")
        const email = uu. get("email")
        let photoUrl = uu. get("photoUrl")
        if (photoUrl == undefined) {
          photoUrl = ""
        }
        this.assignedUsers.push({"id": id, "email": email, "img": photoUrl, "name": name, "show": false})
      })
    })
  })
}

getFirstEditableField() { // determines the first editor to make it focused for editing, this way user has one click less
  for (let i = 0; i < this.fields.length; i++) {
    if ((this.fields[i].type == 'plain')||(this.fields[i].type == 'html')||(this.fields[i].type == 'datealert')) {
      return i
    }
  }
  return -1
}

getName() { // creates content of the post
  let name = "" 
  if (this.templateKey != 'diary') {
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type == "html" || this.fields[i].type == "plain") {
        name += this.fields[i].content + " </br>"
      }
    }
    if (name == "") { // if no html fields were found create post description out of plain fields
      for (let i = 0; i < this.fields.length; i++) {
        if (this.fields[i].type == "plain") {
          name += this.fields[i].content + "</br>"
        }
      }
    }
  } else { // TU TRZEBA INACZEJ GENEROWAC PODGLAD DLA DIARY!!!
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type == "label") {
        name += "<b>"+this.fields[i].content + "</b></br>"
      }
      if (this.fields[i].type == "html" || this.fields[i].type == "plain") {
        name += this.fields[i].content + " </br>"
      }
    }
  }
  return name;
}

setAutofocus() {
  this.isAutofocusSet = true
}

getTemplateColor(templateKey: string) {
  for (let i = 0; i < this.templates.length; i++) {
    if (this.templates[i].key == templateKey) {
      return this.templates[i].color
    }
  }
  return "#ffffff"
}

focusIn(fieldIndex: number) { // launched after clicking on field
  this.currentFieldIndex = fieldIndex
}

turnEdit(fieldIndex: number) {
  this.currentFieldIndex = fieldIndex
  this.isPostUpdated = true
}

stripTags(htmlString: string) {
  if (htmlString != undefined) {
    var div = document.createElement("div");
    div.innerHTML = htmlString;
    return div.innerText;
  } else {
    return ""
  }
}

showToolbar(i: number, show: boolean) {
  this.editors.forEach(e => {
    e.showToolbar = false
  })
  this.editors[i].showToolbar = show
  if (show == true) {
    this.editor.destroy()
    this.editor = new Editor()
    setTimeout(() => {
      this.editor.commands.focus().scrollIntoView().exec()
    }, 500)
  }
}

commandEnterHit(i: number) {
  this.addField(i, "html", "", false, true)
  this.isCommandEnterHit = true
} 

hideToolbar(i: number) {
  setTimeout(() => {
    if (this.isCommandEnterHit == false) {
      this.editors[i].showToolbar = false
      this.currentFieldIndex = -1
      //this.editor.destroy()
    } else {
      this.isCommandEnterHit = false
    }
  },300)
}

generatePostKey() {
  this.firestoreService.addEmptyContent(this.userId, this.organizationKey, this.projectKey, this.projectName).then(result => {
    this.postKey = result
  })
}

getImages() {
  if (this.imageURLs != undefined) {
    this.imageURLs.splice(0, this.imageURLs.length)
  } else {
    this.imageURLs = []
  }
  const db = this.firestoreService.getApps()
  this.isDownloadAvailable = false
  this.isListening = true
}

remove() {
 // this.dialog.closeAll();
  const ref = this.dialog.open(ConfirmingDialogComponent, {
    width: '400px',
    data: {"content": "Do you want to delete this content and corresponding documents?", "onlyCloseButton": false}
  });
  ref.afterClosed().subscribe((result) => { // if file was already added, leave popup after showing message
    if (result == true) {
      this.isDeleted = true
      this.sendDelete.emit(this.isDeleted)
     // this.dialogRef.close(this.data)
//     setTimeout(() => {
      this.firestoreService.removePost(this.postKey, this.organizationKey, this.projectKey).then(() =>{
        this.close(true)
        this.firestoreService.showSnackBar("The content was deleted.");
      }) // TU COŚ NIE DZIALA BO POTEM TEN POST WYSZUKUJE!!! 
//     })
    }
  })
}

async generateTags(content: string = "", pos: number = -1, isAll: boolean = false) {
  this.removeSlashFromPreviousField()
  this.post.tags = await this.search.generateTags(this.organizationKey, this.postKey, this.globalTags, this.fields, this.post.tags, content, pos, isAll)
}

signInForEmail() { // signs in user for email notifications
  this.firestoreService.updateScheduledNotification(this.organizationKey, this.postKey, this.userId, this.fields, this.post.nameHTML, true).then(() => {
    this.firestoreService.showSnackBar("You have been signed in for email notification.")
  })
}

save(doClose: boolean = true) { 
  this.name = this.getName()
  if (this.name.length > 500) { // limit name length to 500 characters
    this.name = this.name.slice(0, 500)+"..."
  }
  this.htmlName = this.name
  if (this.isDownloadAvailable == undefined) {
    this.isDownloadAvailable = false
  }
  let parentName = ""

  if (this.isDeleted == true) {
  } else {
    this.listenContent.emit(false);
    if (doClose == true) {
      this.isLoadingLabelVisible = true
    }
    this.recountFieldSequence()
    let promiseArray: Promise<any>[] = []
    const content = this.search.aggregateContent(this.fields)

    promiseArray.push(this.gemini.getGeminiEmbeddings([{"key": this.postKey, "chunk": content}]).then(result => {
      const res = result[0].values
      this.firestoreService.updateContentEmbedding(this.organizationKey, this.projectKey, this.postKey, res, this.embeddingModel, this.type)
    }))
     

    promiseArray.push(this.firestoreService.updateWorkpackageName(this.organizationKey, this.projectKey, this.projectName, this.postKey, this.userId, this.userDisplayName, this.name, parentName, this.type, this.embeddingModel, this.htmlName, this.fields).then(() => {
      this.sendNameUpdate.emit({name: this.stripTags(this.name), htmlName: this.htmlName})
    }))
    //promiseArray.push(this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields))
    promiseArray.push(this.firestoreService.updateWorkpackageColor(this.organizationKey, this.postKey, this.color, this.areKidsColored).then(() => {
      this.sendColorUpdate.emit(this.color)
    }))
  //   if (post.isRead != result.isRead || post.isTop != result.isTop || post.isFavourite != result.isFavourite) {
    promiseArray.push(this.firestoreService.setContentReadToggles(this.organizationKey, this.userId, [{"contentKey": this.postKey, "isRead": this.isRead, "isTop": this.isTop, "isFavourite": this.isFavourite}]))

    this.firestoreService.updateScheduledNotification(this.organizationKey, this.postKey, this.userId, this.fields, this.post.nameHTML, false)
  //   }
    if (doClose == true) {
      Promise.all(promiseArray).then(() => { // wait with refreshing until all data is updated successfully
        if (this.name == "") {
          this.name = "Untitled " + this.type
        }
        this.close(false)
       // this.closePopup.emit({isDeleted: false, isPostUpdated: true, isListening: this.isListening, name: this.name, htmlName: this.htmlName})
        this.listenContent.emit(true);
        this.isLoadingLabelVisible = false

      }) // let listen to content list after a while
    }
    this.isPostUpdated = false
  }
}

updateCoverImage(url: string) {
  this.post.coverImageURL = url
  this.sendCoverImageUpdate.emit(this.post.coverImageURL)
  this.isListening = true
}

enterEdit() {
 // this.isPostUpdated = true
}

getLinkedPosts(postKeys: string[]) { // gets data about linked posts base on list of linked posts keys
  const db = this.firestoreService.getApps()
  this.linkedPosts.splice(0, this.linkedPosts.length);
}

addLinkedPost() {
  if (this.isAddPostClicked == false) {
    this.isAddPostClicked = true
  } else {
    this.isAddPostClicked = false
    let linkedPostKey = this.getPostKey(this.addedPostLink)
    if (linkedPostKey != "") {
    //  this.firestoreService.addLinkedPost(this.organizationKey, this.projectKey, this.postKey, this.fieldKeyWithLinks.toString(), linkedPostKey)  POZNIEJ NAPRAWIE BLAD!!!
      let links = this.fields[this.fieldKeyWithLinks].links
      links.push(linkedPostKey)
      this.getLinkedPosts(links)
      this.addedPostLink = ""
    }
  }
}

getPostKey(link: string) {
  let index = link.lastIndexOf("/")+1
  if (index > 0) {
    return link.slice(index, link.length)
  } else {
    return ""
  }
}

copyTextToClipboard(text: string) {
  text = "https://wroolo.com/channel/"+this.organizationKey+"/"+text
  this.firestoreService.copyTextToClipboard(text);
}

setColorClicked() {
  this.isColorPalleteVisible = true
}

changeComplete(event: any) {
  this.color = event.color.hex
  this.post.color = event.color.hex
  this.isColorPalleteVisible = false
  this.isPostUpdated = true
}

setColorKids() {
  this.isPostUpdated = true
  this.areKidsColored = !this.areKidsColored
}

isFileUploaded(arg: {"isFileUploaded": boolean, "url": string}) {
  if (arg.isFileUploaded == true) {
    this.getImages()
  }
}

showPeopleSearchPopup() { //shows popup where people can be found
  this.showSearchwModal = true
}

showTimeTrackerPopup() {
 this.showTimeTracker = true
}

timeTrackerClosed(result: boolean) {
  this.showTimeTracker = false
}

receivedFoundUsers(value: string[]) {
  this.showSearchwModal = false
  this.showUserDetailsModal = false
  this.assignedUsers.forEach(a => {
    a.show = false
  })
  this.getAssignedUser()
}

showUserDetails(i: number) {
  this.assignedUsers[i].show = true
}

fieldDropped(event: CdkDragDrop<any[]>) {
  moveItemInArray(this.fields, event.previousIndex, event.currentIndex);
  this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields)
}

removeSlashFromPreviousField() {
  if (this.isSlashDetected == true && this.focusedFieldIndex > -1) { // remove slash from previous field
    const str = this.fields[this.focusedFieldIndex].content
    const lastIndex = str.lastIndexOf(' /');
    if (lastIndex > -1) {
      this.fields[this.focusedFieldIndex].content = str.slice(0, lastIndex) + str.slice(lastIndex + 2);
    }
    this.focusedFieldIndex = -1
    this.isSlashDetected = false
  }
}

addField(i: number, noteType: string, content = "", doClose: boolean = true, doFocusIn: boolean = true) { // adds new field to array of fields
  this.removeSlashFromPreviousField()
  this.focusedFieldIndex = i
  this.isPostUpdated = true
  const uid = crypto.randomUUID()
  this.isPostUpdated = true
  if (noteType == "progressbar") {
    content = JSON.stringify({ "value": 0, "label": "% of respondents" })
  }
  if (noteType == "dropdown") {
    content = JSON.stringify({ "selected": 0, "label": "pick option", "options": [{"label": "option1", "selected": false}, {"label": "option2", "selected": false}, {"label": "option3", "selected": false}], "isMultichoice": false, "isPersonaDropdown": false })
  }
  if (noteType == "multidropdown") {
    content = JSON.stringify({ "selected": 0, "label": "pick option", "options": [{"label": "option1", "selected": false}, {"label": "option2", "selected": false}, {"label": "option3", "selected": false}], "isMultichoice": true, "isPersonaDropdown": false })
  }
  if (noteType == "icescore") {
    content = JSON.stringify([ { "label": "Example item", "impact": 0, "ease": 0, "confidence": 0, "score": 0 },  { "label": "Example item", "impact": 0, "ease": 0, "confidence": 0, "score": 0 },  { "label": "Example item", "impact": 0, "ease": 0, "confidence": 0, "score": 0 }])
  }
  let f: PostField = {content: content, key: "customfield"+uid, links: [], noteType : noteType, placeholder : "Type your content here, or press / to add new field", sequence : i+0.5, type: noteType, uid: this.firestoreService.generateUID(), date: "", isExpanded: true, label: ""}
  this.fields.splice(i+1, 0, f)
  if (noteType == "html" || noteType == "datealert") {
    this.initiateEditors()
  }
  this.recountFieldSequence()
  if (doClose == true) {
    this.save(false) // I need to save post after adding new field
  }
  if (doFocusIn == true && (noteType == "html" || noteType == "datealert")) {
    setTimeout(() => {
      this.showToolbar(i+1, true)
    },300)
  }
}

getDateDifference(dateString: string): number { // calculates difference between today and indicated date
  const today = new Date();
  const date = new Date(dateString);
  const timeDiff = date.getTime() - today.getTime();
  const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return dayDiff;
}

getAlertClass(dateString: string): string { // determines class of alert for datealert field
  const dayDiff = this.getDateDifference(dateString);
  if (dayDiff > 3 && dayDiff <= 7) {
    return 'alert alert-info';
  } else if (dayDiff >= 1 && dayDiff <= 3) {
    return 'alert alert-warning';
  } else  if (dayDiff >= 0 && dayDiff < 1) {
    return 'alert alert-danger';
  }
  return '';
}

recountFieldSequence() {
  for (let i = 0; i < this.fields.length; i++) {
    this.fields[i].sequence = i
  }
}

onKeyDown(event: KeyboardEvent, fieldIndex: number, fieldType: string): void {
  if (event.key === 'Enter') {
    if (((event.metaKey || event.ctrlKey)&&fieldType == "html") || (fieldType == "plain")) {         // Command+Enter (or Control+Enter) for html field and just Enter for plain field
      event.preventDefault();
      this.addField(fieldIndex, fieldType, "", false)
    }
  }
  if (event.key === 'Shift') {
    this.shiftKeyPressed = true
  }
}

deleteField(i: number, dontAsk: boolean = false) { // removes indicated field from array of fields
  this.removeSlashFromPreviousField()
  this.focusedFieldIndex = i
  if (dontAsk == false) {
    const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
      width: '400px',
      data: {"content": "Do you want to delete this field?", "onlyCloseButton": false}
    });
    dialogConfirmingRef.afterClosed().subscribe((result) => { // if file was already added, leave popup after showing message
      if (result == true) {
        this.fields.splice(i, 1)
        this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields)
        this.firestoreService.showSnackBar("The field has been deleted.")
      } 
    })
  } else {
    this.fields.splice(i, 1)
    this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields)
  }
}

scrollToField(index: number) {
  if (document && document.getElementById('field'+index)) {
    const section = document.getElementById('field'+index);
    if (section) {
      section.scrollIntoView();
    }
  }
}

showAIAssistant(index: number) {
  this.aggregatedContent = ""
  if (index == 0) {
    this.aggregatedContent = this.stripTags(this.search.aggregateContent(this.fields))
  } else {
    this.aggregatedContent = this.stripTags(this.fields[index].content)
  }
  const dialogConfirmingRef = this.dialog.open(AiassistantpopupComponent, {
    data: {"content": this.aggregatedContent, "isReadOnly": this.isReadOnly}
  });
  dialogConfirmingRef.afterClosed().subscribe((result) => { // if file was already added, leave popup after showing message
    if (result.completionGenerated == true) {
      this.addField(index, "html", result.completion, false)
      setTimeout(() => {
        this.scrollToField(index)
      }, 500)
    } 
  })
}

closeAddTemplatePopup() { // closes new template popup
  this.showAddTemplatePopup = false
  this.addTemplateName = ""
}

close(isDeleted: boolean) {
  this.name = this.firestoreService.stripHTML(this.name)
  if (this.name == "") {
    this.name = "Untitled " + this.type
  }
  this.post.name = this.name
  this.post.nameHTML = this.htmlName

  if (this.isPostUpdated == true && isDeleted == false) {
    const ref = this.dialog.open(ConfirmingDialogComponent, {
      width: '400px',
      data: {"content": "You updated content. Are you sure to close without saving?", "onlyCloseButton": false}
    });

    ref.afterClosed().subscribe((result) => { // if file was already added, leave popup after showing message
      if (result == true) {
        this.closePopup.emit({isDeleted: false, isPostUpdated: false, isListening: this.isListening, name: this.name, htmlName: this.htmlName})
        this.dialogRef.close({"key": this.postKey, "name": this.post.name, "htmlName": this.post.nameHTML, "color": this.post.color})
      }
    })
  } else {
    this.closePopup.emit({isDeleted: isDeleted, isPostUpdated: false, isListening: this.isListening, name: this.name, htmlName: this.htmlName})
    this.dialogRef.close({"key": this.postKey, "name": this.post.name, "htmlName": this.post.nameHTML, "color": this.post.color, "isDeleted": isDeleted, "isPostUpdated": this.isPostUpdated, "isListening": this.isListening, "endDate": this.endDate, "progressPercent": this.progressPercent, "startDate": this.startDate, "manHours": this.manHours})
  }
}

saveNewTemplate() { // closes new template popup and saves new template
  if (this.addTemplateName.length > 0) {
    this.showAddTemplatePopup = false
    let fields: { key: string; name: string; sequence: number; type: string; }[] = []
    for (let i = 0; i < this.fields.length; i++) {
      const fieldType = this.fields[i].type
      let fieldContent = this.fields[i].content
      if (fieldType != "label") {
        fieldContent = ""
      }
        fields.push({
          "key": i.toString(),
          "name": fieldContent,
          "type": fieldType,
          "sequence": i
        })
    }
    this.firestoreService.addTemplate(this.organizationKey, this.addTemplateName, this.type, fields).then(() => {
      this.firestoreService.showSnackBar("New template has been saved.")
    })
    this.addTemplateName = ""
  } else [
    this.firestoreService.showSnackBar("You need to provide templatee name.")
  ]
}

showTemplatePopup() {
  this.showAddTemplatePopup = true
}

copyToKnowledgeBase() {
  this.dialog.closeAll();
  const ref = this.dialog.open(ConfirmingDialogComponent, {
    width: '400px',
    data: {"content": "Do you want to create new post out of this task?", "onlyCloseButton": false}
  });
  ref.afterClosed().subscribe((result) => { // if file was already added, leave popup after showing message
    if (result == true) {
    //  ref.close(this.data)
      this.firestoreService.copyWorkpackage(this.organizationKey, this.postKey, "post").then(rr => {
        this.firestoreService.showSnackBar("New post has been added to knowledge base.");
      })
    }
  })
}

copyToKanban() {
  // TO TRZEBA NAPISAC!!! TU TRZEBA SIE ZASTANOWIC JAK UMIEJSCAWIAC NA KANBAN NOWE ZADANIE: jaki parent i status???
}

updateJsonField(field: {"table": string, "fieldKey": string}) {
  this.isPostUpdated = true
  field.table = '{"rows":'+field.table+"}"
  this.listenContent.emit(false);
  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].key == field.fieldKey) {
      this.fields[i].content = field.table
      this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields).then(() => { 
        this.listenContent.emit(true);
      })
    }
  }
}

scrapePage(url: string, pos: number) { // 
  this.isPostUpdated = true
  this.removeSlashFromPreviousField()
  url = this.firestoreService.stripHTML(url)
  url = this.firestoreService.ensureHttps(url)
  if (this.firestoreService.isValidUrl(url) == false) {
    this.firestoreService.showSnackBar("The URL is not valid.")
  } else if (url != "") {
    this.firestoreService.showSnackBar("The page is being scrapped.")
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, while the page is being scrapped."
    this.search.scrapeWebPAge(url).then(result => {
      this.firestoreService.showSnackBar("The page is being summarized.")
      this.loadingMessage = "The page has been scrapped. Please wait, while summary is generated."
      if (result != "error") {
      this.scrapedPage = result
      this.addField(pos, "html", this.scrapedPage, false, true)
      } else {
        this.firestoreService.showSnackBar("The page could not be scrapped.")
      }
    this.isLoadingLabelVisible = false
    this.loadingMessage = "Please wait, while data is loaded."
    })
  } else {
    this.firestoreService.showSnackBar("You need to provide URL.")
  }
}

async getImageDescription(url: string) {
  this.isPostUpdated = true
  this.removeSlashFromPreviousField()
  this.firestoreService.showSnackBar("The image is analyzed. Please wait...")
  this.listenContent.emit(true);
  const result = await this.searchService.getPromptWithImage("Desrcibe all objects in the image. If there are any captions, add them to associated objects. Try to identify the location of the image.", url, this.userId, this.organizationKey, this.postKey, this.projectKey, "post")
  if(result == undefined || result == "error") {
      this.firestoreService.showSnackBar("The image could not be analyzed. You can try again.")
    } else {
    //  const currentDate = new Date().toDateString()
      if (this.site == "productly") {
        this.currentFieldIndex = this.fields.length
      }
      this.addField(this.currentFieldIndex, "html", result, false, true)
      setTimeout(() => {
        this.scrollToField(this.currentFieldIndex)
      }, 500)
    }
    this.isLoadingLabelVisible = false
    if (this.captureImage == true) { // if image was captured, close popup immediately
      this.save(true)
    }
  this.listenContent.emit(false);
  this.closePopup.emit({isDeleted: false, isPostUpdated: true, isListening: this.isListening, name: this.name, htmlName: this.htmlName})
}

recievedImageUrl(url: string) {
  this.lastImageURL = url
}

addAcceptanceCriteria() {
  this.isLoadingLabelVisible = true
  this.loadingMessage = "Please wait, while tasks are generated."
  const taskContent = this.search.aggregateContent(this.fields)
  const prompt = `Generate acceptance criteria for user story ${taskContent}.\n Return only the acceptance criteria in html format. \n\n`
  this.searchService.getGPTChatResponse(prompt).then((result: any) => {
    result = this.extractContent(result);
    this.isLoadingLabelVisible = false
    this.addField(this.fields.length, "label", "Acceptance criteria", false)
    this.addField(this.fields.length, "html", result, false)
    this.firestoreService.showSnackBar("Acceptance criteria have been added.")
  }).catch((error: any) => {
    console.error(error)
    this.isLoadingLabelVisible = false
    this.firestoreService.showSnackBar("Acceptance criteria could not be generated.")
  })
}

extractContent(html: string): string | null {  // This regex captures content between any opening and closing tag
  const regex = /<([a-zA-Z0-9]+)>([\s\S]*?)<\/\1>/;
  const match = html.match(regex);
  return match ? match[2].trim() : null; // match[2] contains the content between the tags
}

removeTag(tag: string) {
  this.post.tags = this.post.tags.filter((t: string) => t !== tag);
  this.firestoreService.updateContentTags(this.organizationKey, this.postKey, this.post.tags).then(() => {
    this.firestoreService.showSnackBar("The tag has been removed.")
  })
}

editTag(tag: string, index: number) {
  this.editedTagIndex = index
  this.editedTag = tag
}

saveEditedTag(tag: string) {
  this.editedTagIndex = -1
  this.post.tags = this.post.tags.map((t: string) => t == tag ? this.editedTag : t).filter((t: string) => t !== ""); // remove empty tags
  this.firestoreService.updateContentTags(this.organizationKey, this.postKey, this.post.tags).then(() => {
    this.firestoreService.showSnackBar("Tags have been updated.")
  })
}

addTag() {
  this.editedTagIndex = this.post.tags.length
  this.post.tags.push("")
  this.editedTag = ""
}

closeNewTagEditor() {
  this.editedTag = ""
  this.editedTagIndex = -1
}

toggleContextMenu(index: number) {
  if (this.visibleContextMenuIndex == index) {
    this.visibleContextMenuIndex = -1
  } else {
    this.visibleContextMenuIndex = index
  }
}

updateJsonFieldChecklist(event: any) {
  this.isPostUpdated = true
  this.listenContent.emit(false);
  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].key == event.fieldKey) {
      this.fields[i].content = event.table
      this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields).then(() => { 
        this.listenContent.emit(true);
      })
    }
  }
}

async updateJsonFieldDropdown(event: any) {
  this.isPostUpdated = true
  this.listenContent.emit(false);
  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].key == event.fieldKey) {
      this.fields[i].content = event.content
      const fieldType = this.fields[i].type
      await this.firestoreService.updateWorkpackageFields(this.organizationKey, this.postKey, this.fields)
      const contentObj = JSON.parse(this.fields[i].content)
      if (fieldType == "dropdown" || fieldType == "multidropdown") {
      //  const isPersonaDropdown = contentObj.isPersonaDropdown || false
        const selectedPersonas = contentObj.options || []
        for (let j = 0; j < selectedPersonas.length; j++) {
            if (selectedPersonas[j].selected == true) {
              if (this.post.tags.includes(selectedPersonas[j].label) == false) {
                this.post.tags.push(selectedPersonas[j].label)
              }
            } else {
              this.post.tags = this.post.tags.filter((tag: string) => tag !== selectedPersonas[j].label)
            }
        }
        await this.firestoreService.updateContentTags(this.organizationKey, this.postKey, this.post.tags) // update tags representing personas in firestore
      }
      this.listenContent.emit(true);
    }
  }

}

onAddProgressBarField(event: any) {
  this.isPostUpdated = true
  this.addField(this.fields.length, "progressbar", JSON.stringify(event), false, true)
}

onAddHTMLField(event: {"content": string}) {
  this.addField(this.fields.length, "html", event.content, false)
  setTimeout(() => {
    this.scrollToField(this.fields.length - 1)
  }, 100)
}

onAddTableField(event: any[]) {
  this.addField(this.fields.length, "table", JSON.stringify(event), false, true)
}

onAddLabelField(event: string) {
  this.addField(this.fields.length, "label", event, false)
}

onIsLoading(event: boolean) {
  this.loadingMessage = "Please wait, while file is being transcribed. It may take a couple of minutes if you have a long file..."
  this.isLoadingLabelVisible = event
}

onProgressHillClosed(event: {startDate: string, endDate: string, reportedHours: number, progressPercent: number}) {
  this.showTimeTracker = false
  this.startDate = event.startDate
  this.endDate = event.endDate
  this.manHours = event.reportedHours
  this.progressPercent = event.progressPercent
}

async retrieveFieldsExpansionStatus() {
  let expandedFields: string[] = []
  await this.firestoreService.getFieldExpasionStatus(this.organizationKey, this.userId, this.postKey).then((result: string[]) => {
    expandedFields = result
  })
  return expandedFields
}

updateFieldsExpansionStatus() {
  let expandedFields: string[] = []
  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].isExpanded == true) {
      expandedFields.push(this.fields[i].key)
    }
  }
  return expandedFields
}

toggleLabelSection(index: number) {
  this.fields[index].isExpanded = !this.fields[index].isExpanded
  let aboveLabelFieldIndex = -1
  for (let i = 0; i < this.fields.length; i++) {
    if (this.fields[i].type == "label") {
      aboveLabelFieldIndex = i
    } else {
      if (aboveLabelFieldIndex != -1) {
        this.fields[i].isExpanded = this.fields[aboveLabelFieldIndex].isExpanded
      }
    }
  }
  this.firestoreService.updateFieldExpasionStatus(this.organizationKey, this.userId, this.postKey, this.updateFieldsExpansionStatus())
}



}
